// extracted by mini-css-extract-plugin
export default {"container":"style_container__6OKFP","headingContainer":"style_headingContainer__OITsd"};